const UPLOAD_RATE_MB_PER_SECOND = 5; // mean time from several calculation performed in 09.2024 by nivzelber

export const calculateUploadTimeEstimation = (file: File) => {
    return file.size / 1024 ** 2 / UPLOAD_RATE_MB_PER_SECOND;
};
